type EnumLiteralsOf<T extends unknown> = T[keyof T];
export const PaymentCodStatus = Object.freeze({
  WAITING: 1 as const,
  PAID: 2 as const,
});

export type PaymentCodStatus = EnumLiteralsOf<typeof PaymentCodStatus>;
